// extracted by mini-css-extract-plugin
export default {"buttonContainer":"modal_buttonContainer__-HAh9","close":"modal_close__PKngw","container":"modal_container__o8zno","content":"modal_content__kCzt-"};